export const Data = [
  {
    type: "zh",
    itemTitle:"解决方案",
    itemMore:"查看更多",
    itemCount:"建设区域乃至全国领先的口腔舒适化激光诊疗中心，打造集医疗、科研、教学为一体的现代化激光诊疗平台。开展激光诊疗技术的临床研究和应用推广，形成具有自主知识产权的技术成果，推动口腔医学技术创新与发展。",
    imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
    itemData:[
      {
        index:1,
        text1:"针对医院（科室）",
        imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
        back:"#5daf34",
        p1:"#FFFFFF",
        path:"dyy"
      },
      {
        index:2,
        text1:"针对医生",
        imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
        back:"#5daf34",
        p1:"#FFFFFF",
        path:"dys"
      },
      {
        index:3,
        text1:"针对患者",
        imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
        back:"#5daf34",
        p1:"#FFFFFF",
        path:"dhz"
      }
      // ,
      // {
      //   index:4,
      //   text1:"服务公立民营XXX",
      //   imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
      //   back:"#5daf34",
      //   p1:"#FFFFFF"
      // }
    ]
  },
  {
    type: "en",
    itemTitle:"Solutions",
    itemMore:"View More",
    itemCount:"Establishing leading regional and nationwide comfort-focused laser dental treatment centers, creating a modern laser treatment platform that integrates medical care, research, and education.",
    imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
    itemData:[
      {
        index:1,
        text1:"For Hospitals/Departments",
        imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
        back:"#5daf34",
        p1:"#FFFFFF",
        path:"dyy"
      },
      {
        index:2,
        text1:"For Doctors",
        imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
        back:"#5daf34",
        p1:"#FFFFFF",
        path:"dys"
      },
      {
        index:3,
        text1:"For Patients",
        imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
        back:"#5daf34",
        p1:"#FFFFFF",
        path:"dhz"
      }
      // ,
      // {
      //   index:4,
      //   text1:"服务公立民营XXX",
      //   imgUrl:"https://www.victrum.com/image/sy/jjfa.jpg",
      //   back:"#5daf34",
      //   p1:"#FFFFFF"
      // }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/jjfa.js